import { APIClient } from "../helpers/api_helper";
import {
  DashboardWidgetId,
  DashboardWidgetLayoutItem,
} from "../helpers/dashboardLayoutCatalog";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export type DashboardLayoutPayload = {
  widgets: DashboardWidgetLayoutItem[];
};

const isWidgetId = (value: unknown): value is DashboardWidgetId =>
  typeof value === "string" &&
  [
    "insights",
    "kpi_clients",
    "kpi_professionals",
    "kpi_appointments_today",
    "kpi_orders_open",
    "kpi_packages_expiring",
    "appointments_today",
    "quick_actions",
    "recent_improvements",
  ].includes(value);

const normalizeWidgets = (raw: unknown): DashboardWidgetLayoutItem[] => {
  if (!Array.isArray(raw)) {
    return [];
  }

  return raw
    .map((row, index) => {
      if (!row || typeof row !== "object") {
        return null;
      }
      const item = row as Record<string, unknown>;
      if (!isWidgetId(item.id)) {
        return null;
      }
      return {
        id: item.id,
        visible: item.visible !== false,
        order: typeof item.order === "number" ? item.order : index,
      } as DashboardWidgetLayoutItem;
    })
    .filter((row): row is DashboardWidgetLayoutItem => row !== null);
};

export const getDashboardLayout = async (): Promise<DashboardLayoutPayload | null> => {
  const response = await api.get<ApiResponse<DashboardLayoutPayload | null>>(
    "/me/dashboard-layout"
  );

  if (!response?.data) {
    return null;
  }

  return {
    widgets: normalizeWidgets(response.data.widgets),
  };
};

export const putDashboardLayout = (
  widgets: DashboardWidgetLayoutItem[]
): Promise<ApiResponse<DashboardLayoutPayload>> =>
  api.put("/me/dashboard-layout", { widgets });

export const deleteDashboardLayout = (): Promise<
  ApiResponse<null>
> => api.delete("/me/dashboard-layout");
